import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'

import RapportvaktLandingPage from './pages/RapportvaktLandingPage'
import RapportvaktPage from './pages/RapportvaktPage'
import RapportvaktSamplePage from './pages/RapportvaktSamplePage'
import RapportvaktDigestPage from './pages/RapportvaktDigestPage'
import RapportvaktAboutPage from './pages/RapportvaktHelpPage'
import RapportvaktPublisherPage, { RapportvaktPublishersPage } from './pages/RapportvaktPublisherPage'
import RapportvaktLoginPage from './pages/RapportvaktLoginPage'
import RapportvaktNotFoundPage from './pages/RapportvaktNotFoundPage'

/**
 * Punktlista, standalone.
 *
 * These are the same seven routes Rapportvakt had under /rapportvakt/* on
 * utforskadata.se, moved to the root of their own domain, plus the catch-all
 * 404 every app needs once it lives on its own domain. See
 * src/config/rapportvakt.js for the path constants and helpers every page
 * and link in the app builds its URLs from — nothing here hardcodes a path
 * a second time.
 *
 * The catch-all renders RapportvaktNotFoundPage rather than redirecting to
 * "/": an unknown path is not the homepage, and Netlify serving dist/404.html
 * with a real 404 status (see netlify.toml) is what actually keeps a stale or
 * mistyped link from being indexed — this route is what a reader sees, on the
 * same page, if they get there by a client-side navigation instead.
 */
function App() {
  return (
    <HelmetProvider>
      <Router>
        <Routes>
          <Route path="/" element={<RapportvaktLandingPage />} />
          <Route path="/app" element={<RapportvaktPage />} />
          <Route path="/app/:tab" element={<RapportvaktPage />} />
          <Route path="/exempel/:slug" element={<RapportvaktSamplePage />} />
          {/* SCB's weekly digest. "/scb/vecka-:week-:year" is not a valid
              React Router 6 pattern (it cannot match two params inside one
              path segment), so the whole "vecka-36-2026" segment is one
              param and RapportvaktDigestPage parses it — see
              rapportvaktDigestPath in src/config/rapportvakt.js. */}
          <Route path="/scb/:weekSlug" element={<RapportvaktDigestPage />} />
          <Route path="/digest/:slug" element={<RapportvaktDigestPage />} />
          <Route path="/om" element={<RapportvaktAboutPage />} />
          {/* /hjalp was the page's old path (renamed to /om in 2026-09); the
              server-level 301 in netlify.toml handles a hard load, this
              covers a client-side navigation to the old path instead. */}
          <Route path="/hjalp" element={<Navigate to="/om/" replace />} />
          {/* Where a mailed login link lands (docs/plan/2026-09-11-magic-
              link-login.md). Not in the sitemap and noindex/nofollow — see
              getRapportvaktLoginSeo in src/config/seoRoutes.js — but still
              prerendered to its own dist/logga-in/index.html so a hard
              reload or a click straight from an email client works. */}
          <Route path="/logga-in" element={<RapportvaktLoginPage />} />
          <Route path="/utgivare" element={<RapportvaktPublishersPage />} />
          <Route path="/utgivare/:slug" element={<RapportvaktPublisherPage />} />
          <Route path="*" element={<RapportvaktNotFoundPage />} />
        </Routes>
      </Router>
    </HelmetProvider>
  )
}

export default App
